import {
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
} from '@angular/core';
import * as L from 'leaflet';
import { PTicketService } from '../../../services/p-ticket.service';
import { pTicket, pTicketMap } from '../../../interfaces/pTicket';
import { HttpParams } from '@angular/common/http';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { ReportingMapDetailComponent } from '../reporting-map-detail/reporting-map-detail.component';
import {
  MatCard,
  MatCardHeader,
  MatCardModule,
  MatCardTitle,
} from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { HeaderTitleService } from '../../../services/header-title.service';
import { globalUser } from '../../../helpers/globalFields';
import { ActiveFilter } from '../../../interfaces/active-filter';
import { Filters } from '../../../mock-data/mock-filters';
import { forkJoin } from 'rxjs';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-reporting-map',
  standalone: true,
  imports: [
    NgIf,
    MatProgressSpinner,
    MatButtonModule,
    MatCard,
    MatMenuModule,
    MatIconModule,
    MatCardHeader,
    MatCardTitle,
    MatCardModule,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatTableModule,
  ],
  templateUrl: './reporting-map.component.html',
  styleUrl: './reporting-map.component.scss',
})
export class ReportingMapComponent {
  private testMap!: L.Map;
  mapIDTest: string = 'test-map';
  ptickets!: Record<string, number>;
  testmapOverlayFeatures!: any;
  isLoading: boolean = true;
  leaderboardList: any[] = [];
  displayedColumns: string[] = ['country', 'count', 'action'];
  private countryLayer: L.GeoJSON | null = null;
  isNavigatingToList: boolean = false;
  constructor(
    private pTicketService: PTicketService,
    private resolver: ComponentFactoryResolver,
    private userService: UserService,
    private headerTitleService: HeaderTitleService,
    private appRef: ApplicationRef,
    private injector: Injector,
    private router: Router,
  ) { }

  ngOnInit(): void {
    globalUser.getUserStream().subscribe((user) => {
      this.isLoading = true;
      if (user) {
        if (this.countryLayer) {
          this.countryLayer.remove();
          this.countryLayer = null;
        }
        this.pTicketService.getForMap().subscribe((ptickets) => {
          this.ptickets = ptickets;
          fetch('assets/geojson-worldmap/custom.geo.json')
            .then((response) => response.json())
            .then((data) => {
              this.testmapOverlayFeatures = data.features;
              const ticketCountMap: Record<string, number> = {
                ...this.ptickets,
              }; // already like { "AB": 1, "CD": 2 }

              const overlayResults = this.testmapOverlayFeatures.map(
                (mapfeature: {
                  properties: { iso_a2_eh: string; name: string };
                }) => {
                  const iso = mapfeature.properties.iso_a2_eh;
                  const count = ticketCountMap[iso] || 0; // default 0 if not in the record

                  return {
                    mapfeature: mapfeature.properties.iso_a2_eh,
                    name: mapfeature.properties.name,
                    count: count,
                  };
                },
              );

              // Optional: filter out countries with 0 tickets
              //const filteredOverlayResults = overlayResults.filter(result => result.count > 0);

              console.log(overlayResults);

              let maxCount = 0;

              this.leaderboardList = overlayResults.map(
                (result: { mapfeature: any; count: number }) => ({
                  name: result.mapfeature,
                  count: result.count,
                }),
              );
              this.leaderboardList.sort((a, b) => b.count - a.count);
              overlayResults.forEach(
                (result: { count: number; mapfeature: string | number }) => {
                  const count = result.count;
                  ticketCountMap[result.mapfeature] = count;
                  if (count > maxCount) maxCount = count;
                },
              );

              let selectedLayer: L.Layer | null = null;

              this.countryLayer = L.geoJSON(data, {
                style: (feature) => {
                  const iso = feature!.properties.iso_a2_eh;
                  const count = ticketCountMap[iso] || 0;
                  return {
                    fillColor: this.getColor(),
                    color: '#333',
                    weight: 1,
                    fillOpacity: this.getOpacity(count, maxCount),
                  };
                },
                onEachFeature: (feature, layer) => {
                  const iso = feature.properties.iso_a2_eh;
                  const name = feature.properties.name;
                  const count = ticketCountMap[iso] || 0;
                  layer.on('click', () => {
                    if (selectedLayer && this.countryLayer)
                      this.countryLayer.resetStyle(selectedLayer);
                    (layer as L.Path).setStyle({ color: '#000', weight: 2 });
                    selectedLayer = layer;

                    const popupContent = this.createPopupComponent({
                      name: feature.properties.name,
                      code: iso,
                      count: ticketCountMap[iso] || 0,
                    });
                    L.popup()
                      .setLatLng([
                        feature.properties.label_y,
                        feature.properties.label_x,
                      ])
                      .setContent(popupContent)
                      .openOn(this.testMap);
                  });
                },
              }).addTo(this.testMap);
              this.isLoading = false;
            });
        });
      }
    });

    this.headerTitleService.setTitle('Map');
    if (this.testMap) {
      this.testMap.off();
      this.testMap.remove();
    }

    let standard_filter = new HttpParams();
    let start = new Date();
    start.setFullYear(2021);
    let end = new Date();
    // Constructing the query parameters for the date range filter
    const startDate = start.toISOString(); // Convert date to ISO format
    const endDate = end.toISOString(); // Convert date to ISO format
    // Remove any existing 'updatedAt' filters from the HttpParams
    standard_filter = standard_filter
      .delete('updatedAt[$gte]')
      .delete('updatedAt[$lte]');
    // Add the filter for 'updatedAt' to the HttpParams
    standard_filter = standard_filter
      .append('updatedAt[$gte]', startDate) // Using the $gte operator for start date
      .append('updatedAt[$lte]', endDate); // Using the $lte operator for end datev

    this.testMap = L.map(this.mapIDTest, { zoomControl: false }).setView(
      [35, -35],
      3,
    );
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      detectRetina: true,
    }).addTo(this.testMap);

    requestAnimationFrame(() => this.testMap.invalidateSize());
    this.pTicketService.getForMap().subscribe((ptickets) => {
      this.ptickets = ptickets;
      console.log(this.ptickets);
      fetch('assets/geojson-worldmap/custom.geo.json')
        .then((response) => response.json())
        .then((data) => {
          this.testmapOverlayFeatures = data.features;
          const ticketCountMap: Record<string, number> = { ...this.ptickets }; // already like { "AB": 1, "CD": 2 }

          const overlayResults = this.testmapOverlayFeatures.map(
            (mapfeature: {
              properties: { iso_a2_eh: string; name: string };
            }) => {
              const iso = mapfeature.properties.iso_a2_eh;
              const count = ticketCountMap[iso] || 0; // default 0 if not in the record

              return {
                mapfeature: mapfeature.properties.iso_a2_eh,
                name: mapfeature.properties.name,
                count: count,
              };
            },
          );

          // Optional: filter out countries with 0 tickets
          //const filteredOverlayResults = overlayResults.filter(result => result.count > 0);

          console.log(overlayResults);

          let maxCount = 0;

          this.leaderboardList = overlayResults.map(
            (result: { mapfeature: any; count: number }) => ({
              name: result.mapfeature,
              count: result.count,
            }),
          );
          this.leaderboardList.sort((a, b) => b.count - a.count);
          overlayResults.forEach(
            (result: { count: number; mapfeature: string | number }) => {
              const count = result.count;
              ticketCountMap[result.mapfeature] = count;
              if (count > maxCount) maxCount = count;
            },
          );

          let selectedLayer: L.Layer | null = null;

          this.countryLayer = L.geoJSON(data, {
            style: (feature) => {
              const iso = feature!.properties.iso_a2_eh;
              const count = ticketCountMap[iso] || 0;
              return {
                fillColor: this.getColor(),
                color: '#333',
                weight: 1,
                fillOpacity: this.getOpacity(count, maxCount),
              };
            },
            onEachFeature: (feature, layer) => {
              const iso = feature.properties.iso_a2_eh;
              const name = feature.properties.name;
              const count = ticketCountMap[iso] || 0;
              layer.on('click', () => {
                if (selectedLayer && this.countryLayer) this.countryLayer.resetStyle(selectedLayer);
                (layer as L.Path).setStyle({ color: '#000', weight: 2 });
                selectedLayer = layer;

                const popupContent = this.createPopupComponent({
                  name: feature.properties.name,
                  code: iso,
                  count: ticketCountMap[iso] || 0,
                });
                L.popup()
                  .setLatLng([
                    feature.properties.label_y,
                    feature.properties.label_x,
                  ])
                  .setContent(popupContent)
                  .openOn(this.testMap);
              });
            },
          }).addTo(this.testMap);
          this.isLoading = false;
        });
    });
  }

  onOpenTickets(event: Event, iso: any): void {

    const filterDef = Filters.find((f) => f.db_key === "pct_countrycode");
    if (!filterDef) {
      console.warn(`No filter definition found for field: pct_countrycode`);
      return;
    }
    let countryFilters: ActiveFilter[] = []
    countryFilters.push({
      id: crypto.randomUUID(),
      key: filterDef,
      value: iso,
    });
    console.log(countryFilters);

    this.isNavigatingToList = true;

    forkJoin([
      this.userService.saveTableFilters('tCC', countryFilters),
      this.userService.saveTableFilters('pCC', countryFilters),
    ]).subscribe({
      next: () => {
        this.router.navigate(['/pTickets/list']);
      },
      error: (err) => {
        console.error('Failed to apply drill-down filters:', err);
        this.isNavigatingToList = false;
      },
    });
  }



  private createPopupComponent(data: any): HTMLElement {
    // 1. Create component dynamically
    const factory = this.resolver.resolveComponentFactory(
      ReportingMapDetailComponent,
    );
    const componentRef: ComponentRef<ReportingMapDetailComponent> =
      factory.create(this.injector);

    // 2. Pass data to the component
    componentRef.instance.name = data.name;
    componentRef.instance.iso = data.code;
    componentRef.instance.count = data.count;

    // 3. Attach to Angular change detection
    this.appRef.attachView(componentRef.hostView);

    // 4. Get DOM element
    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    return domElem;
  }

  getColor(): string {
    return `rgb(63, 81, 181)`;
  }

  getOpacity(ticketcount: number, maxCount: number): number {
    let normalized = maxCount > 0 ? (ticketcount / maxCount) * 0.9 : 0;
    if (0 < ticketcount && ticketcount < 10) {
      normalized = 0.15;
    }

    return normalized;
  }

  ngOnDestroy(): void { }
}
